'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileIdsAreResolved = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _every = require('transmute/every');

var _every2 = _interopRequireDefault(_every);

var _resolvedAttachmentsForThreadFromProps = require('./resolvedAttachmentsForThreadFromProps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileIdsFromProps = function getFileIdsFromProps(state, _ref) {
  var fileIds = _ref.fileIds;
  return fileIds;
};

var fileIdsAreResolved = exports.fileIdsAreResolved = (0, _reselect.createSelector)([_resolvedAttachmentsForThreadFromProps.resolvedAttachmentsForThreadFromProps, getFileIdsFromProps], function (resolvedAttachments, fileIds) {
  return (0, _every2.default)(function (fileId) {
    return Boolean((0, _get2.default)(fileId, resolvedAttachments));
  }, fileIds);
});


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/selectors/fileIdsAreResolved.js
// module id = 599
// module chunks = 2 3